module.exports = import("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest");;